import axios from '../http'

export function getUserConfigs() {
  var config = localStorage.getItem("USER_CONFIG")

  if (config != undefined && config != null) {
    return JSON.parse(config)
  } else {
    axios.get('Dialogue/gDOE').then(function ({
      data
    }) {
      var json = JSON.stringify(data);
      localStorage.setItem("USER_CONFIG", json)
      return data;
    })
  }
}



// WEBPACK FOOTER //
// ./src/utils/getUserConfig.js